module.exports = __webpack_public_path__ + "img/ennetix-overview.55262ef3.png";